import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const EditFunding = () => {
    const params = useParams();
    const [funding, setFunding] = useState(null);
    const { isLoading: isLoadingfunding, refetch: getFunding } = useQuery(
        "edit-funding",
        async () => {
          return await apiClient.get(`/api/show-fundings`);
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                const fundingData = res.data.fundings.find(f => f.id == params.id);
                if (fundingData) {
                    setFunding(fundingData);
                    setFundingForm({
                        amount: fundingData.amount,
                        gateway: fundingData.gateway,
                        transaction_id: fundingData.transaction_id,
                        status: fundingData.status
                    });
                }
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

    const initialFunding = {
        amount: '',
        gateway: '',
        transaction_id: '',
        status: 'pending'
    }
    
    const [error, setErros] = useState('');
    const [fundingForm, setFundingForm] = useState(initialFunding);

    const onChange = (e) =>
    setFundingForm({ ...fundingForm, [e.target.name]: e.target.value });


    const { isLoading: isSendingRequest, mutate: postFunding } = useMutation(

        async () => {
          return await apiClient.post(`/api/update-funding`, {
            funding_id: params.id,
            amount: fundingForm.amount,
            gateway: fundingForm.gateway,
            transaction_id: fundingForm.transaction_id,
            status: fundingForm.status
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.errors || myerror.message)  
            const event2 = new Event('processed');
            window.dispatchEvent(event2);     
          },
        }
      );
      const onSubmit = () =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postFunding();
      } 

      useEffect(() => {
        getFunding();
      }, []);

  return (
    <div style={{marginTop: '70px'}}>
        {funding !== null && 

        <Grid container px={2} mt={4}  mb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
        <Grid item xs={12} sm={12} md={8}>
            <Card sx={{background: 'linear-gradient(145deg, rgba(22, 26, 30, 0.8) 0%, rgba(31, 35, 41, 0.6) 100%)', border: '1px solid #2B3139'}}>
                <CardContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Edit Funding/Deposit
                    </Typography>
                    <Typography variant="h5" component="div">
                        Funding Details
                    </Typography>
                </CardContent>
                <Divider />
                <CardContent>
                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="amount">Amount</InputLabel>
                            <OutlinedInput
                            id="amount"
                            name="amount"
                            label="Amount"
                            type='number'
                            value={fundingForm.amount}
                            onChange={onChange}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="gateway">Payment Gateway</InputLabel>
                            <OutlinedInput
                            id="gateway"
                            name="gateway"
                            label="Payment Gateway"
                            value={fundingForm.gateway}
                            onChange={onChange}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="transaction_id">Transaction ID</InputLabel>
                            <OutlinedInput
                            id="transaction_id"
                            name="transaction_id"
                            label="Transaction ID"
                            value={fundingForm.transaction_id}
                            onChange={onChange}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="status">Status</InputLabel>
                            <Select
                                id="status"
                                name="status"
                                label="Status"
                                value={fundingForm.status}
                                onChange={onChange}
                            >
                                <MenuItem value="pending">Pending</MenuItem>
                                <MenuItem value="successful">Successful</MenuItem>
                                <MenuItem value="failed">Failed</MenuItem>
                                <MenuItem value="rejected">Rejected</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    {error && <Typography color="error" sx={{ marginTop: 2 }}>{JSON.stringify(error)}</Typography>}

                </CardContent>
                <Divider />
                <CardActions>
                    <Button 
                        component={RouterLink}
                        to="/list-fundings"
                        size="small" 
                        variant="outlined"
                    >
                        Back
                    </Button>
                    <Button disabled={isSendingRequest} onClick={onSubmit} size="small" variant="contained" color="primary">
                        {isSendingRequest ? <CircularProgress size={20} /> : 'Update'}
                    </Button>
                </CardActions>
            </Card>
        </Grid>
        </Grid>

        }
    </div>
  );
};

export default EditFunding;
